module.exports = __webpack_public_path__ + "img/pilihlaptop-logo-min.3c1ca2b4.png";